import { Component, Input } from '@angular/core';
import { DateInputComponent, FormComponentLookup } from '@ptl/forms';
import moment, { isMoment, Moment } from 'moment';
import { MOMENT_PARSE_FORMAT, SUBMISSION_DATE_FORMAT } from '../../../../../producer/mass-upload-grid/interfaces/mug-submission.interface';
import { MassUploadEntryConfig } from '../../../../../producer/mass-upload-grid/interfaces/mass-upload-grid.interface';
import { MassUploadGridService } from '../../../../../producer/mass-upload-grid/services/mass-upload-grid.service';
import { environment } from 'src/environments/environment';
import { MomentTimeZoneEnum } from 'src/app/shared/enums/moment-timezone.enum';

@FormComponentLookup('mass-upload-grid-control-date')
@Component({
  selector: 'app-mass-upload-date-form-control',
  templateUrl: './mass-upload-date-form-control.component.html',
  styleUrl: '../../mass-upload-form-control.component.scss',
  standalone: false
})
export class MassUploadDateFormControlComponent extends DateInputComponent{
  // This is needed to override the default EntryConfig type for this variable
  @Input() entry: MassUploadEntryConfig;

  constructor(
    private mugService: MassUploadGridService
  ) {
    super();
  }


  // NOTE: This is a special case where this component is not a child of mass-upload-form-control like the other custom controls for the grid.
  // This means that there is some duplication of the process here, but we gain a much larger validation benefit by inheriting the date control directly
  //
  // moment will always throw a warning for the date format MM/DD/YYYY if it is not explicitly stated when parsing a value
  // the form control value should always be a moment, the "setDefaultValue" should always be a string formatted in MM/DD/YYYY


  ngOnInit() {
    this.mugService.transformExcelDateToMoment(this.entry, this.selfAsFormControl);

    this.resetFormValue(this.getValue(this.entry.formControlAttributes.setDefaultValue));
  }

  getValue(value?: any): Moment {
    if (isMoment(value)) {
      return value;
    }
    else if (typeof value === 'string') {
      // standardize MM/DD/YYYY format on the incoming value to account for M, MM, D, DD combinations
      // DEVON - we create this moment IMMEDIATELY as aligned with the timezone of the app - RATHER THAN - casting it as a timezone after creating IN OUR timezone
      const parsedDate = moment.tz(value, MOMENT_PARSE_FORMAT, MomentTimeZoneEnum[environment.configs.siteTimeZone] );
      if (parsedDate.isValid()) {
        return parsedDate;
      }
    }
    
    return null;
  }

  /**
   * @description Resets the form value specifically for the mass-upload-grid. 
   * The grid does not use the redux state, it relies on the formControl value and the .setDefaultValue property. 
   * NOTE: If value needs to be an object, you must override this method AND ensure 'setDefaultValue' is always a string.
   */
  resetFormValue(value?: Moment) {
    if (value && isMoment(value)) {
      this.selfAsFormControl.setValue(value);
      this.entry.formControlAttributes.setDefaultValue = value.format(SUBMISSION_DATE_FORMAT);
    }
    else {
      this.selfAsFormControl.setValue(null);
      this.entry.formControlAttributes.setDefaultValue = null;
    }
  }

  initTriggers() {
    this.subscribeToFormStream(this.entry.base.formListeners);
    this.broadcastToFormStream(this.entry.base.formBroadcast);
    this.setFormControlValidators();
  }

  onBlur() {
    if (moment.isMoment(this.selfAsFormControl.value)) {
      this.entry.formControlAttributes.setDefaultValue = this.selfAsFormControl.value?.format(SUBMISSION_DATE_FORMAT);
    }
    else {
      this.entry.formControlAttributes.setDefaultValue = this.selfAsFormControl.value;
    }
  }
}
